function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5005 5C12.5005 5 6.50046 8 6.50046 14C6.50046 18.3278 9.60224 20.0359 11.3423 20.6621C7.87866 23.7328 4.75827 24.5293 4.75827 24.5293C4.50083 24.5935 4.27944 24.7574 4.14282 24.9849C4.0062 25.2123 3.96553 25.4847 4.02976 25.7422C4.09399 25.9996 4.25786 26.221 4.48532 26.3576C4.71279 26.4943 4.9852 26.5349 5.24265 26.4707C5.24265 26.4707 8.93085 25.5326 12.7973 22.0664C12.7984 22.0695 12.7982 22.0711 12.7993 22.0742C13.4373 21.5662 14.0364 21.051 14.5434 20.543L22.7934 12.293C22.7934 12.293 23.2055 14.707 21.2055 16.707L15.9555 21.957C15.2995 22.613 14.5218 23.2731 13.6958 23.9141C14.6878 25.4421 16.4425 27 19.5005 27C25.5005 27 28.5005 22.667 28.5005 15V5H17.5005Z"
});

function SvgA4F6B38Becd11Ec9D640242Ac120002(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA4F6B38Becd11Ec9D640242Ac120002);
export default ForwardRef;